import React from 'react'
import "./About.css"
// import "./"
// import Typical from 'react-typical'

const About = () => {
  return (
    <div  id="about" className="about section">
        <div className='about_photo'>
          <img src="./images/ruchi.png" alt="mypic" className='home-img'/>
        </div>

        <div className='about_info'>
          <h2>About me</h2>
          
        <p id='user-detail-intro'>
          I am From Dahod Gujarat. Currently I am a student of MASAI SCHOOL.  I am eager to kickstart my career as a full stack web developer. With a strong foundation in front-end and back-end technologies such as HTML, CSS, JavaScript, React.js, Node.js, MongoDB, Git, and GitHub, I am passionate about creating dynamic and user-friendly web applications. I am a quick learner, a problem solver, and an excited to work on challenging projects that allow me to grow my skills and knowledge in the field of web development.</p>

        <div>

        <button id="resume-button-2" className='btn_resume'><a download="Ruchi-Agrawal-Resume.pdf" href="./Ruchi-Agrawal-Resume.pdf" 
                        id="resume-link-2" onClick={()=> window.open(
                          "https://drive.google.com/file/d/1xDygTcnSEOTMcLW0Q_DY8_iVT_U6V9TG/view?usp=sharing",
                          "_blank"
                        )}>Resume</a></button>

        
        </div>
       
        </div>
    </div>
  )
}

export default About